
export const w3_close = () => {
    // Get the Sidebar
var mySidebar = document.getElementById("mySidebar");

// Get the DIV with overlay effect
var overlayBg = document.getElementById("myOverlay");

mySidebar.style.display = "none";
overlayBg.style.display = "none";

}

